import { Navigate } from 'react-router-dom';
import { useCurrentOrganization } from 'queries';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { CenteredLoader, MainDashboardPage, PageTitle } from 'components';
import { NewFeatureBanner } from 'components/NewFeatureBanner';
import { useTranslation } from 'react-i18next';

export const EmptyPanel = () => {
  const { t } = useTranslation();
  const { data: organization, isLoading } = useCurrentOrganization();

  const panels = organization?.panels?.filter((panel) => !panel.deletedAt);

  if (panels && panels.length > 0) {
    return <Navigate to={`/new-panel/${panels[0].id}`} />;
  }

  return (
    <AnalyticsCategoryProvider category={Categories.PANEL}>
      <PageTitle title={t('participants.metaTitle')} />
      <MainDashboardPage>
        <NewFeatureBanner />
        {isLoading ? <CenteredLoader /> : <div>Empty Panel (TODO)</div>}
      </MainDashboardPage>
    </AnalyticsCategoryProvider>
  );
};
